// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";
import { connect }       from "preact-redux";
import { Form, Field }   from "formaggio";

import { save   as updateCustomer,
         SAVING as UPDATING_CUSTOMER,
         SAVED  as UPDATED_CUSTOMER } from "store-reducers/customer";

import Button     from "../Button";
import InputField from "../InputField";

const TLD_BLACKLIST = ["example.com"];

function removeBlacklistedTLDs(email) {
  return email && TLD_BLACKLIST.indexOf(email.split("@").pop()) === -1 ? email : "";
}

@connect(
  state => ({
    customer : state.customer,
  }),
  { updateCustomer }
)
export default class CheckoutForm extends PureComponent {
  static defaultProps = {
    invoiceMethods: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      formData: {
        email: removeBlacklistedTLDs(props.customer.data.email)
      },
      readOnlyFields: [],
    };
  }

  toggleEdit = () => this.setState({ editing: !this.state.editing });

  updateForm = formData => this.setState({ formData });

  handleSubmit = event => {
    event.preventDefault();

    if (this.props.customer.state !== UPDATING_CUSTOMER) {
      this.props.updateCustomer(this.state.formData);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customer.state    === UPDATING_CUSTOMER &&
        nextProps.customer.lastEvent === UPDATED_CUSTOMER  &&
       !nextProps.customer.error) {
      this.setState({ editing: false });
    }
  }

  render({ customer, readOnly, updatingCustomer }: Props, { editing, formData, readOnlyFields }: any, { t }: Context) {
    return (
      <section
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <header class={styles.header}>
          <h1 class={classNames(
                styles.heading,
                "h2"
              )}>

            {t("FORM.HEADING")}
          </h1>
        </header>

        <Form
            class={styles.fields}
            state={formData}
            onSubmit={this.handleSubmit}
            onChange={this.updateForm}>

          <div
              class={classNames(
                styles.column,
                {[styles.flat]: editing || updatingCustomer}
              )}>

            {editing || updatingCustomer ?
              <Field
                  type="email"
                  name="email"
                  autocomplete="email"
                  readOnly={readOnly || updatingCustomer}
                  component={InputField}
                  class={styles.input}
                  autoFocus={true}
              /> :
              <span class={styles.value}>
                {removeBlacklistedTLDs(customer.data.email)}
              </span>
            }
          </div>

          <div class={styles.column}>
            {editing || updatingCustomer ?
              <Button
                  modifiers="inline"
                  key="submitEmailButton"
                  type="submit">

                {t("FORM.SUBMIT")}
              </Button> :
              <Button
                  modifiers="inline"
                  onClick={this.toggleEdit}>

                {updatingCustomer ?
                  t("FORM.SAVING") :
                  t("FORM.EDIT_EMAIL")}
              </Button>
            }
          </div>
        </Form>

        <div class={styles.info}>
          <p>
            {t("FORM.INFO")}
          </p>
        </div>
      </section>
    );
  }
}
